/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import PropTypes from "prop-types";
import useTranslation from "next-translate/useTranslation";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { Breadcrumbs, Link, Forbidden } from "@/components/core";
import { useActiveRoute } from "@/hooks/useActiveRoute";

export function PageWrapper({
  children,
  redirectToNewPage = false,
  formPage,
  unStyled = false,
}: any) {
  const { t } = useTranslation("common");
  const { activeRoute } = useActiveRoute();
  const access = activeRoute?.getAuthorization();

  if (access === false) {
    return <Forbidden />;
  }

  return !unStyled ? (
    <Box p={2} mb={formPage ? "7em" : ""}>
      <Stack my={1}>
        <Breadcrumbs />
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center" my={2}>
        <Typography variant="h6" component="h6" sx={{ fontWeight: "500" }}>
          {t(`routes:${activeRoute?.key}`)}
        </Typography>
        {redirectToNewPage && (
          <Link href={`${activeRoute?.toUrl()}/new`}>
            <Button
              type="button"
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                padding: "4px 1em",
                fontWeight: 600,
                minWidth: "120px",
              }}
            >
              {t("add_new")}
            </Button>
          </Link>
        )}
      </Stack>
      <Box sx={{ backgroundColor: "white", p: "1em" }}>{children}</Box>
    </Box>
  ) : (
    <div>{children}</div>
  );
}

PageWrapper.propTypes = {
  children: PropTypes.any.isRequired,
  redirectToNewPage: PropTypes.bool,
  formPage: PropTypes.any,
  unStyled: PropTypes.bool,
};
